import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { defaultTestimonial } from "@circle-react/helpers/paywallCustomizationHelpers";
import { useCheckoutTabContext } from "../../CheckoutTabContext";
import { localeRoot } from "../../constants";
import { TestimonialForm } from "./Forms/TestimonialForm";
import { AddButton } from "./components/AddButton";
import { ContainerForm } from "./components/ContainerForm";
import { FormGroup } from "./components/FormGroup";
import { FormItemGroup } from "./components/FormItemGroup";

const toggleDataTestId = "paywall-customization-testimonial-toggle";
const containerDataTestId = "paywall-customization-testimonial-container";

export const TestimonialProperties = () => {
  const { watch, getValues } = useFormContext();
  const { testimonialPropertiesForm } = useCheckoutTabContext();

  const { fields, append, remove } = testimonialPropertiesForm || {
    fields: [],
    append: () => {},
    remove: () => {},
  };

  const isEnabled = Boolean(
    watch("paywall_customization_attributes.testimonial_properties.enabled"),
  );
  const hasReachedLimit = fields.length >= 10;
  const hasReachedMinimum = fields.length <= 1;
  const onAddItem = () => append(defaultTestimonial);

  return (
    <ContainerForm
      titleLocale={t([localeRoot, "builder.testimonials.show_testimonials"])}
      toggleName="paywall_customization_attributes.testimonial_properties.enabled"
      toggleDataTestId={toggleDataTestId}
      containerDataTestId={containerDataTestId}
    >
      <FormGroup isEnabled={isEnabled}>
        {fields.map((field, index: number) => {
          const formName = `paywall_customization_attributes.testimonial_properties.testimonials.${index}`;
          const onDuplicateClick = () => append({ ...getValues(formName) });
          const onRemoveClick = () => remove(index);

          return (
            <FormItemGroup
              key={field.id}
              index={index}
              fields={fields}
              hasReachedLimit={hasReachedLimit}
              hasReachedMinimum={hasReachedMinimum}
              onDuplicateClick={onDuplicateClick}
              onRemoveClick={onRemoveClick}
              dataTestId="testimonial-form-item-group"
            >
              <TestimonialForm
                keyFormId={field.id}
                name={formName}
                disabled={!isEnabled}
              />
            </FormItemGroup>
          );
        })}
      </FormGroup>
      <AddButton
        label={t([localeRoot, "builder.testimonials.add_item"])}
        onClick={onAddItem}
        disabled={hasReachedLimit || !isEnabled}
        dataTestId="add-testimonial-button"
      />
    </ContainerForm>
  );
};
